import {
	useActive,
	useChainedCommands,
	useCommands,
	useRemirrorContext,
} from "@remirror/react";
import React, { useEffect, useRef, useState, MutableRefObject } from "react";
import Icon from "../../../../../../ui/Icon/Icon";
// import { orderedList } from '../../../../../../assets/svgs/text-editor-toolbar/ol';
import leftAlign from "../../../../../../assets/svgs/text-editor-toolbar/left-align";
import centerAlign from "../../../../../../assets/svgs/text-editor-toolbar/center-align";
import rightAlign from "../../../../../../assets/svgs/text-editor-toolbar/right-align";
import ToolbarButton from "../ToolbarButton/ToolbarButton";
import downArrowheadIcon from "../../../../../../assets/svgs/downArrowheadIcon";
import WhiteHoverTip from "../../../../../../ui/WhiteHoverTip/WhiteHoverTip";

type ListOptionsProps = {
	disabled?: boolean;
};

const AlignmentDropdown: React.FC<ListOptionsProps> = (props) => {
	const active = useActive();
	const commands = useChainedCommands() as any;

	const alignmentTypes = [
		{
			active: () => active.paragraph({ nodeTextAlignment: "left" }),
			handler: () => {
				commands.setTextAlignment("left").focus().run();
			},
			source: leftAlign("white"),
			newHoverTip: <WhiteHoverTip text="Left Align" />,
		},
		{
			active: () => active.paragraph({ nodeTextAlignment: "center" }),
			handler: () => {
				commands.setTextAlignment("center").focus().run();
			},
			source: centerAlign("white"),
			newHoverTip: <WhiteHoverTip text="Center Align" />,
		},
		{
			active: () => active.paragraph({ nodeTextAlignment: "right" }),
			handler: () => {
				commands.setTextAlignment("right").focus().run();
			},
			source: rightAlign("white"),
			newHoverTip: <WhiteHoverTip text="Right Align" />,
		},
	];

	let activeTool = alignmentTypes[0];

	if (active.paragraph({ nodeTextAlignment: "center" })) {
		activeTool = alignmentTypes[1];
	} else if (active.paragraph({ nodeTextAlignment: "right" })) {
		activeTool = alignmentTypes[2];
	}

	return (
		<div className="AlignmentDropdown-container">
			<ToolbarButton
				active={() => {
					return activeTool.active();
				}}
				disabled={props.disabled}
				handler={() => {}}
				source={activeTool.source}
				newHoverTip={<WhiteHoverTip text="Align" />}
				dropdownMenu={alignmentTypes.map((x) => {
					return {
						active: x.active,
						handler: x.handler,
						source: x.source,
						newHoverTip: x.newHoverTip,
					};
				})}
			/>
		</div>
	);
};
export default AlignmentDropdown;
